import { render, staticRenderFns } from "./AdvertisementPreview.vue?vue&type=template&id=2bae1340&"
import script from "./AdvertisementPreview.vue?vue&type=script&lang=js&"
export * from "./AdvertisementPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports